import Reveal from "./Reveal";
import Eyebrow from "./Eyebrow";

const STEPS = [
    {
        n: "01",
        title: "Planlıyoruz",
        desc: "Markanızı ve aylık içerik ihtiyacınızı belirliyoruz.",
    },
    {
        n: "02",
        title: "Çekiyoruz",
        desc: "İşletmenizde doğal ve gerçek içerikler üretiyoruz.",
    },
    {
        n: "03",
        title: "Hazırlıyoruz",
        desc: "Video, fotoğraf ve tasarımları yayına hazır hale getiriyoruz.",
    },
    {
        n: "04",
        title: "Yayınlıyoruz",
        desc: "İçerikleri planlıyor ve reklam süreçlerini yönetiyoruz.",
    },
];

export default function Process() {
    return (
        <section id="surec" data-testid="process-section" className="scroll-mt-24 py-24 md:py-32">
            <div className="mx-auto w-full max-w-[1240px] px-6 md:px-10">
                <Reveal>
                    <Eyebrow>Süreç</Eyebrow>
                    <h2 className="mt-5 font-display text-4xl leading-tight text-cream sm:text-5xl lg:text-6xl">
                        Basit bir sistem.
                    </h2>
                </Reveal>

                <div className="mt-16 md:mt-20">
                    {STEPS.map((s, i) => (
                        <Reveal key={s.n} delay={i * 0.06}>
                            <div
                                data-testid={`process-step-${s.n}`}
                                className={`grid grid-cols-1 gap-3 border-t border-cream/10 py-9 md:grid-cols-12 md:items-baseline md:gap-8 md:py-12 ${
                                    i === STEPS.length - 1 ? "border-b" : ""
                                }`}
                            >
                                <span className="font-display text-4xl text-cream/20 md:col-span-2 md:text-5xl">
                                    {s.n}
                                </span>
                                <h3 className="font-display text-3xl text-cream md:col-span-4 md:text-4xl">
                                    {s.title}
                                </h3>
                                <p className="max-w-md text-sm leading-relaxed text-fog md:col-span-6 md:text-base">
                                    {s.desc}
                                </p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
